__turbopack_context__.v({
  "container": "Layout-module__98JVbG__container",
  "groupTitle": "Layout-module__98JVbG__groupTitle",
  "kicker": "Layout-module__98JVbG__kicker",
  "pageSection": "Layout-module__98JVbG__pageSection",
  "sectionDescription": "Layout-module__98JVbG__sectionDescription",
  "sectionTitle": "Layout-module__98JVbG__sectionTitle",
});
